<template>
    
    <div class="scrollable-table-container">

        <table class="orders">
        <thead>
            <!-- чтобы добавить неперетаскиваемый заголовок, нужно добавить класс draggable=".itemDrag" -->
            <draggable v-model="headersKeys" tag="tr" :item-key="key => key" draggable=".itemDrag">
            <template #item="{ element: index }">
                <th v-if="index == 'menu'" class="cell-setting i-cog" @click="showModalFields = true" data-draggable="false">
                    <mdicon class="cog-icon" name="cog" width="20" height="20"/>
                </th>
                <th v-else scope="col" class="itemDrag">
                <div class="flex-between-block th-width pointer" @click="selectSortField(index)">
                    {{ headers[index] }}
                    <span class="wd-sort-i">
                    <mdicon v-if="sortField == index && sortASC == index" name="chevron-up" width="18" height="16"></mdicon>
                    <mdicon v-else-if="sortField == index && sortDESC == index" name="chevron-down" width="18" height="16"></mdicon>
                    <mdicon v-else class="flag-hover-sort" name="chevron-up" width="18" height="16"></mdicon>
                    </span>
                </div>
                </th>
            </template>
            </draggable>
            <tr class="row-title"></tr>
        </thead>
        <tbody>
            <!-- Перечень заказов. Детальная информация по блоку в разделе 6.3.2.3.
            ВАЖНО! В блок Е должны выводиться заказы, статус которых НЕ завершен и НЕ отклонен. -->
            <tr v-for="item in data" :key="item" @click="openDetailPage(item.id)">

            <!-- Раскрывающийся список для заказов. Должен содержать элементы:
            - Копировать заказ. При клике на элемент должен создаваться новый заказ с следующими полями:
                Номер заказа - новый номер
                Дата создания - текущая дата
                Статус - черновик
                Остальные поля (включая товары) точно как в копируемом заказе. -->
            <td class="cell-setting c-gray add-menu" @mouseover="showPopover($event, item.id)" @mouseleave="hidePopover(item.id)">
                <img v-show="type != 'price'" class="hov-img" src="@/assets/img/icon_menu.svg" />
                
                <div class="container-burger-menu popover" v-show="isPopoverVisible && currentPopoverIndex === item.id && type != 'price'">
                    <div v-if="type == 'order' || type == 'orderSearch'" @click.stop="copyPage(item.id)">Копировать</div>
                    <div v-if="type == 'order' || type == 'orderSearch'" v-show="item.status == 'Черновик' || item.status == 'На согласовании (Клиент)'" @click.stop="editPage(item.id)">Редактировать</div>
                    <div v-if="type == 'kp' || type == 'price'" @click.stop="openDetailPage(item.id)">Открыть</div>
                </div>
                <div v-if="item.countNewMessages && item.countNewMessages > 0" class="count-messages">
                    {{ item.countNewMessages }}
                </div>
            </td> 

            <td v-for="index in headersKeys.slice(1)" :key="index" :class="getCellClass(index)">
                <span v-if="index == 'status'" :class="getOrderClass(item[index])">{{ item[index] }}</span>
                <a v-else-if="index == 'fileRef' && type == 'price'" :href="item[index]" class="file-table-btn" download target="_blank" @click.stop>
                    Скачать прайс-лист 
                    <img class="hov-img" src="@/assets/img/save-file.png" />
                </a>
                <span v-else>{{ item[index] }}</span>
            </td>
            </tr>
        </tbody>
        </table>
        
    </div>

    <div v-if="showModalFields" class="modal-vue" :class="{ 'fade-in': showModalFields, 'fade-out': !showModalFields }">
        <span class="container-icon" title="Закрыть" @click="closeModal">
        <mdicon name="close" width="22" height="22"/> 
        </span> 
        <p class="modal-title">Поля таблицы</p>
        <div class="fields-table-select-container">
            <div 
                class="block-cb block-field-hover"
                v-for="(header, index) in allHeaders" 
                :key="index"
                @click="addField(index)"
                :class="[selectedFields.includes(index) ? 'active-field' : '']"
            >
                <input 
                    type="checkbox" 
                    :value="index"
                    v-model="selectedFields"
                >
                {{ header }}
            </div>
        </div>
        <button 
        class="btn btn-default"
        type="submit"
        @click="saveFields()"
        >
        Сохранить
        </button>
    </div>

    <!-- Затемнение фона -->
  <div v-if="showModalFields" class="overlay"></div>
    
  </template>
  
  <script>
  import draggable from "vuedraggable";

  export default {
    name: 'TableComponent',
    components: {
        draggable
    },
    emits: [
        'sort-table',
        'open-page',
        'copy-page',
        'edit-page'
    ],
    props: {
        allHeaders: {
            type: Object,
            required: true
        },
        headersDefault: {
            type: Object,
            required: true
        },
        dataObject: {
            type: Array,
            required: true
        },
        defaultData: {
            type: Array,
            required: true
        },
        currUserID: {
            type: [String, Number],
            required: true
        },
        type: {
            type: String,
            required: true
        },
        showLeftColumn: {
            type: Boolean,
            default: true
        },
    },

    data() {
        return {
            sortASC: "",
            sortDESC: "",
            sortField: "",
            showModalFields: false,
            headers: {},
            headersKeys: [],
            data: this.dataObject,
            selectedFields: [],
            isPopoverVisible: false,
            currentPopoverIndex: -1,
            draggedColumnIndex: null
        }
    },

    mounted() {
        let localHeaders = localStorage.getItem(this.type + 'Fields_' + this.currUserID)
        if (localHeaders != undefined && localHeaders != "" && localHeaders != null) {
            this.headers = JSON.parse(localHeaders)
        }
        else this.headers = this.headersDefault

        // Заполнить массив чекбоксов для выбора полей
        for (let field in this.headers) {
            this.selectedFields.push(field)
        }
    },

    watch: {
        headersKeys: {
            handler(val) {
                // Переупорядочиваем объект this.headers на основе элементов из headersKeys
                let headersEditedForLocalstorage = JSON.parse(JSON.stringify(this.headers))
                let newHeaders = {}
                val.forEach(key => {
                if (headersEditedForLocalstorage[key]) {
                    newHeaders[key] = headersEditedForLocalstorage[key]
                }
                });
                headersEditedForLocalstorage = newHeaders

                // Сохранение в localStorage работает при каждом изменении порядка в headersKeys,
                // в свою очередь, перед изменением headersKeys, всегда изменяется объект this.headers, 
                // вызывая текущий обработчик
                // Сохранить измененный порядок заголовков для текущего пользователя
                localStorage.setItem(this.type + 'Fields_' + this.currUserID, JSON.stringify(headersEditedForLocalstorage));
            },
            deep: true
        },

        headers: {
            handler() {
                if(this.headersKeys.length < 1) {
                this.headersKeys = Object.keys(this.headers)
                this.headersKeys.unshift("menu")
                }
                else {
                // Объект для ориентира актуальности заголовков this.headers
                // Сначала фильтруем headersKeys, чтобы остались только актуальные заголовки
                this.headersKeys = this.headersKeys.filter(header => Object.keys(this.headers).includes(header))
                
                // Ког в начало массива заголовков, если его нет в массиве
                if(!this.headersKeys.includes("menu"))
                    this.headersKeys.unshift("menu")

                // Затем добавляем недостающие заголовки
                for(let header of Object.keys(this.headers)) {
                    if(!this.headersKeys.includes(header))
                    this.headersKeys.push(header)
                }
                }

            },
            deep: true
        }
    },

    created() {
        this.sortField = ""
        this.sortASC = ""
        this.sortDESC = ""
        // console.log(this.data)
    },

    methods: {
        // Закрыть модалку
        closeModal() {
            this.showModalFields = false;
        },

        // Сохранение заголовков таблицы
        saveFields() {
            // console.log(this.allHeaders)
            let obj = {}
            for(let key in this.allHeaders) {
                if(this.selectedFields.includes(key)) {
                obj[key] = this.allHeaders[key]
                }
            }
            this.headers = obj

            this.showModalFields = false;
        },

        // Выбор поля для сортировки
        selectSortField(field) {
            if(field != "orderNumber") {
                this.sortField = field
                if(this.sortASC != field && this.sortDESC != field) {
                    this.sortASC = field
                    this.data.sort((a, b) => {
                        let fieldA = 0
                        let fieldB = 0
                        
                        if(a[field] != undefined && b[field] != undefined) {
                        fieldA = this.sortingCell(a, field)
                        fieldB = this.sortingCell(b, field)
                        }

                        if (fieldA < fieldB)  return -1;
                        if (fieldA > fieldB)  return 1;
                        else  return 0;
                    });
                }
                else if(this.sortASC == field) {
                    this.sortASC = ""
                    this.sortDESC = field
                    this.data.sort((a, b) => {
                        let fieldA = 0
                        let fieldB = 0

                        if(a[field] != undefined && b[field] != undefined) {
                        fieldA = this.sortingCell(a, field)
                        fieldB = this.sortingCell(b, field)
                        }
                        if (fieldA > fieldB)  return -1;
                        if (fieldA < fieldB)  return 1;
                        else  return 0;
                    });
                }
                else if(this.sortDESC == field) {
                    this.sortDESC = ""
                    this.data = JSON.parse(JSON.stringify(this.defaultData))
                }
                this.$emit('sort-table', this.data);
            }
        },

        // Определение класса для типов ячеек
        getCellClass(name) {
            if(name == "status") return "cell-status"
            else if(name == "typePrice") return "cell-price"
            else return ""
        },

        // Определение названий для ячеек статуса
        getOrderClass(name) {
            if(name == "В работе") return "working"
            else if(name == "Отгружен") return "shipped"
            else if(name == "Черновик") return "draft"
            else if(name == "Отменен") return "cancel"
            else if(name == "На согласовании (Поставщик)") return "processingSupplier"
            else if(name == "На согласовании (Клиент)") return "processingClient"
            else return "default-status"
        },

        sortingCell(obj, field) {
            let fieldObj = 0
            if(obj[field] != "" && obj[field] != " " && obj[field] != 0 && obj[field] != null) {
                if(field == "orderWeight" || field == "total") {
                fieldObj = parseFloat(obj[field])
                }
                else if(field == "created" || field == "shipmentDate" || field == "validFrom" || field == "validTo") {
                fieldObj = this.parseCustomDate(obj[field])
                }
                else {
                if(typeof obj[field] == "number")
                    fieldObj = obj[field]
                else
                    fieldObj = obj[field].toString().toLowerCase();
                }
            }
            return fieldObj
        },

        parseCustomDate(dateStr) {
            const parts = dateStr.split(".");
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            return new Date(year, month, day);
        },

        showPopover(event, index) {
            this.currentPopoverIndex = index;
            this.isPopoverVisible = true;
        },

        hidePopover(index) {
            if (this.currentPopoverIndex === index) {
                this.currentPopoverIndex = -1;
                this.isPopoverVisible = false;
            }
        },

        // Добавить/Удалить id заголовка для таблицы в массив 
        addField(index) {
            if(this.selectedFields.includes(index)) {
                this.selectedFields = this.selectedFields.filter(function(element) {
                return element !== index;
                });
            }
            else
                this.selectedFields.push(index);
        },

        // Открыть заказ по id
        copyPage(id) {
            this.$emit('copy-page', id);
        },

        // Открыть заказ по id
        openDetailPage(id) {
            this.$emit('open-page', id);
        },

        // Открыть заказ по id
        editPage(id) {
            this.$emit('edit-page', id);
        },
    }
  }
  </script>